import { useMemo } from 'react'
import { PlanTier, Entitlements, FeatureKey } from '../types/entitlements'
// Mock data - in production this would come from API/context
const MOCK_PLAN: PlanTier = 'Free'
const MOCK_USAGE = {
  programs: 1,
  playbooks: 1,
  plays: 3,
}
export function useEntitlements(): Entitlements {
  const entitlements = useMemo(() => {
    const plan = MOCK_PLAN
    // Define limits based on plan
    const limits = {
      Free: { programs: 1, playbooks: 1, plays: 3 },
      Growth: { programs: 5, playbooks: Infinity, plays: 50 },
      Scale: { programs: Infinity, playbooks: Infinity, plays: Infinity },
      Enterprise: { programs: Infinity, playbooks: Infinity, plays: Infinity },
    }[plan]
    // Define feature flags based on plan
    const flags = {
      'programs.create': MOCK_USAGE.programs < limits.programs,
      'playbooks.create': MOCK_USAGE.playbooks < limits.playbooks,
      'plays.create': MOCK_USAGE.plays < limits.plays,
      'segments.abm': plan !== 'Free',
      'triggers.event': plan !== 'Free',
      'forecast.bandit': plan === 'Scale' || plan === 'Enterprise',
      'forecast.export_advanced': plan !== 'Free',
      'copilot.tasks': plan === 'Scale' || plan === 'Enterprise',
      'api.access': plan === 'Scale' || plan === 'Enterprise',
      sso: plan === 'Enterprise',
      'governance.audit': plan === 'Enterprise',
      'partner.modeling': plan === 'Scale' || plan === 'Enterprise',
      'field.modeling': plan === 'Scale' || plan === 'Enterprise',
    }
    return {
      plan,
      limits,
      usage: MOCK_USAGE,
      flags,
    }
  }, [])
  return entitlements
}
export function getRequiredPlan(feature: FeatureKey): PlanTier {
  const featurePlanMap: Record<FeatureKey, PlanTier> = {
    'programs.create': 'Growth',
    'playbooks.create': 'Growth',
    'plays.create': 'Growth',
    'segments.abm': 'Growth',
    'triggers.event': 'Growth',
    'forecast.bandit': 'Scale',
    'forecast.export_advanced': 'Growth',
    'copilot.tasks': 'Scale',
    'api.access': 'Scale',
    sso: 'Enterprise',
    'governance.audit': 'Enterprise',
    'partner.modeling': 'Scale',
    'field.modeling': 'Scale',
  }
  return featurePlanMap[feature]
}
export function canUseFeature(
  entitlements: Entitlements,
  feature: FeatureKey,
): boolean {
  return entitlements.flags[feature]
}
export function getUsagePercent(used: number, limit: number): number {
  if (limit === Infinity) return 0
  return Math.round((used / limit) * 100)
}
